export const GET_UAUTH = 'GET_UNAUTH';
export const SET_UAUTH = 'SET_UNAUTH';
export const CLEAR_UAUTH = 'CLEAR_UNAUTH';
